
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"26","height":"26","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"nonzero"}},[_c('path',{attrs:{"d":"M13.01 0A13 13 0 1026 13 12.99 12.99 0 0013.01 0z","fill":"#0A294A"}}),_c('path',{attrs:{"d":"M11.605 20.425a1.937 1.937 0 01-.583-1.431l.07-3.983H7.014A2.015 2.015 0 015 12.995c-.011-.532.2-1.044.584-1.411a2.012 2.012 0 011.41-.585l4.078.08-.07-4.093c-.012-.531.2-1.044.583-1.411.37-.374.875-.582 1.4-.575.528-.007 1.037.2 1.41.575.383.367.595.88.583 1.411v4.083l4.028-.08a2.012 2.012 0 011.41.585c.383.367.595.88.584 1.411a2.015 2.015 0 01-2.014 2.016h-4.028v3.983A2.015 2.015 0 0112.945 21a1.902 1.902 0 01-1.34-.575z","fill":"#FFF"}})])])
          )
        }
      }
    